export const moneyValueToServerFormat = (string) => {
  return string?.replace(',', '_')?.replaceAll('.', ',')?.replaceAll(' ', '')?.replace('_', '.')?.replace('R$', '')
}
